"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const option = {
    animateTime: 800,
    color: {
        primary: 'rgba(0, 150, 250, 1)',
        link: '#1890ff',
        warn: '#faad14',
        danger: 'rgba(255, 77, 79, 1)',
        headText: 'rgba(0, 0, 0, 0.85)',
        text: 'rgba(0, 0, 0, 0.65)',
        secondaryText: 'rgba(0, 0, 0, 0.45)',
        disabledText: 'rgba(0, 0, 0, 0.25)',
        border: '#d9d9d9'
    }
};
exports.default = option;
